<template>
  <div class="flex flex_warp">
    <div v-for="(item,index) in shoplist" :key="index" class="shopbox" :title="item.specs">
      <div class="shopboxover" v-if="shoptype===0">
        <div class="shopboxoverin">

        </div>
      </div>
      <div class="boxtop">
        <shopbanner :shopimg="item.skus" @skusindexfn="skusindexfn" :firstindex="index"></shopbanner>
      	<img v-if="shoptype!==0" class="qianggoubiao" src="../../../../public/img/qianggou.png"/>
      </div>
      <div class="boxcenter txtnowarp2">
        {{item.title}}
      </div>
      <div class="boxbtn flex">
        <div class="boxbtnleft">
          <div class="boxbtnlefttop flex">
            <div class="boxbtnlefttopleft txtnowarp" v-if="shoptype===2">
              <span class="icos">￥</span>{{item.panic_price}}
            </div>
            <div class="boxbtnlefttopleft txtnowarp" v-else>
              <span class="icos">￥</span>{{item.panic_price}}
            </div>
            <div class="boxbtnlefttopright txtnowarp">
              {{item.original_price}}
            </div>
          </div>
          <div class="boxbtnleftbtn flex">
            <div class="boxbtnleftbtnleft">
              已售{{item.sold}}
            </div>
            <div class="boxbtnleftbtnright">
              <div class="boxson1">
                <div class="boxson1num" :style="{width:item.yishoubili +'%'}"></div>
              </div>
<!--              :style="{width:shopSurplus+'%'}"-->
            </div>
          </div>
        </div>
        <div class="boxbtnright" v-if="shoptype===2">
          <span class="son1">
            <img src="@/assets/img/xin.png" alt="" class="son1img">
            <div class="son1txt">
              想买

            </div>
          </span>
          <span class="zetopay">即将开始</span>
        </div>
        <div class="boxbtnright" v-else>
          <img src="@/assets/img/gouwucheman1.png" alt="" @click="postid(index,item.sku_id)">
          <span class="topay" @click="jumpFn(item)">立即抢购</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import shopbanner from '@/views/index/componentsindex/shopbanner_q.vue'
    import qs from 'qs'
    export default {
        props: {
          shoplist: {
            // type: Array,
            default () {
              return [];
            }
          },
          shoptype: Number
        },
        components: {
            shopbanner
        },
        data() {
            return {
              http:'',//域名
              indexs:0,
              shopid:'',
              firstindex:'',
              cunData:[],//用来存储点击的值
              shopCarData:{},
            }
        },
      created() {
        let that = this;
        that.http = that.$publicUrl.http1;
      },
        mounted() {

        },
        methods: {
          postid(index,skuid) {
            console.log(skuid)
            let that = this;
            if(that.$storage.get('user_data') != null) {
              that.shopCarData['user_id'] = that.$storage.get('user_data').user_id;
              that.shopCarData['id'] = skuid;
              that.shopCarData['goods_number'] = 1;
              that.shopCarData['goods_value'] = 1;
              that.shopCarData['activity_id'] = that.shoplist[index].panic_id;
              that.addshopCarFn();
            } else {
              that.$message({
                message: '请先登录或注册',
                type: 'warning'
              });
            }
          },
          //添加购物车方法
          addshopCarFn() {
            let that = this;

            axios({
              method: 'post',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              url: that.$publicUrl.http1 + that.$publicUrl.UsercartaddCart,
              data: qs.stringify(that.shopCarData),

            })
              .then(function(response) {
                //						console.log(response);
                let data = response.data;
                if(data.stateCode == 10000) {

                  that.$message({
                    message: data.msg,
                    type: 'success'
                  });
                } else {
                  that.$message({
                    message: data.msg,
                    type: 'warning'
                  });
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          },
          jumpFn(item){

            let that = this;
            that.$router.push({
              path: "/huodongdetails",
              query: {
                goods_id:item.id,
                panic_id:item.panic_id,
                type:2,
              }
            });
          },
          skusindexfn(data) {
            let that = this;
            let arrs = that.shoplist;

            arrs[data.firstindex].panic_price = arrs[data.firstindex].skus[data.index].panic_price;
            arrs[data.firstindex].original_price = arrs[data.firstindex].skus[data.index].original_price;
            arrs[data.firstindex].sku_id = arrs[data.firstindex].skus[data.index].id;
            arrs[data.firstindex].panic_id = arrs[data.firstindex].skus[data.index].panic_id;
            let arr = [];
						let arr_ = JSON.parse(arrs[data.firstindex].skus[data.index].spec)
						for(let s in arr_) {
							arr.push(arr_[s].name)
						}
						arrs[data.firstindex].specs = arr.toString();
            that.shoplist = arrs;

          }
        },
    }
</script>
<style scoped>
    .shopbox {
        width: 280px;
        margin-bottom: 30px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        display: block;
        margin-right: 15px;
        position: relative;
    }

    .shopbox:hover {
        transition: all 0.2s linear;
        -webkit-box-shadow: 0 1px 6px #dc1e33;
        box-shadow: 0 1px 6px #dc1e33;
        position: relative;
    }

    .boxtop {
        width: 100%;
        height: 270px;
        position: relative;
    }
		.qianggoubiao{
			display: inline-block;
			position: absolute;
			right: 0;
			top: 0;
			width: 64px;
			z-index: 100;
		}
    .boxcenter {
        width: 100%;
        height: 50px;
        line-height: 25px;
        font-size: 14px;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .boxbtn {
        width: 100%;
        padding: 10px;
        box-sizing: border-box;
    }

    .boxbtnleft {
        width: calc(100% - 105px);
    }

    .boxbtnlefttop {
        width: 100%;
    }

    .boxbtnlefttopleft {
        font-size: 18px;
        color: #dc1e33;
        flex: 1;
        height: 30px;
        line-height: 30px;
    }

    .boxbtnlefttopright {
        font-size: 16px;
        color: #a4a4a4;
        flex: 1;
        height: 30px;
        line-height: 30px;
        text-decoration: line-through
    }

    .icos {
        display: inline-block;
        font-size: 16px;
        height: 20px;
        line-height: 30px;
    }

    .boxbtnleftbtn {
        width: 100%;
    }

    .boxbtnleftbtnleft {
        width: 70px;
        height: 20px;
        box-sizing: border-box;
        padding: 0 5px;
        line-height: 20px;
    }

    .boxbtnleftbtnright {
        width: calc(100% - 70px);
        height: 20px;
        box-sizing: border-box;
        padding: 5px;
    }

    .boxson1 {
        width: 100%;
        height: 10px;
        border-radius: 50px;
        background-color: #dddddd;
        position: relative;
    }

    .boxson1num {
        position: absolute;
        top: 0;
        left: 0;
        width: 30%;
        height: 10px;
        border-radius: 50px;
        background-color: #d81023;
    }

    .boxbtnright {
        width: 105px;
        font-size: 22px;
        cursor: pointer;
    }

    .boxbtnright img {
        display: inline-block;
        height: 40px;
        width: 30px;
        object-fit: scale-down;
        margin-right: 5px;
    }

    .boxbtnright span {
        display: inline-block;
        height: 40px;
        font-size: 14px;
    }

    .topay {
        width: calc(100% - 35px);
        display: inline-block;
        height: 40px;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        font-size: 14px;
        background-color: #dc1e33;
        color: #ffffff;
    }

    .zetopay {
        margin-top: 10px;
        width: calc(100% - 35px);
        display: inline-block;
        height: 40px;
        text-align: center;
        line-height: 40px;
        box-sizing: border-box;
        font-size: 14px;
        color: #ffffff;
        vertical-align: top;
        background-color: #666666;
    }

    .boxbtnright .son1 {
        width: 35px;
        height: 50px;
        box-sizing: border-box;
        font-size: 12px;
        color: #999999;
        text-align: center;
    }

    .boxbtnright .son1img {
        width: 20px;
        height: 35px;
        display: block;
        margin: 0 auto;
        object-fit: scale-down;
    }

    .boxbtnright .son1txt {
        width: 100%;
        height: 15px;
        line-height: 15px;
        font-size: 12px;
        text-align: center;
    }

    .shopboxover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 10;
    }

    .shopboxoverin {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
    }

    .shopboxoverin::after {
        content: "已结束";
        width: 100%;
        position: absolute;
        top: 6%;
        right: -40%;
        transform: rotate(45deg);
        background-color: #000000;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        font-size: 16px;
    }
</style>
